import React from 'react';
import { splitHighlightRanges } from '../lib/highlightSplit';

/**
 * HighlightedText — plain text with find hits marked. Walter 2026-08-24.
 *
 * The agenda's rows render `reminder.text` as-is, so a search hit is just a
 * substring: no mirror layer, no measuring, none of the machinery the textarea
 * and CodeMirror paths need. Colours match FindOverlay so a search looks the
 * same wherever it lands. The cutting itself lives in lib/highlightSplit,
 * where it can be tested.
 */
export default function HighlightedText({ text, ranges, current }) {
  const s = String(text ?? '');
  if (!ranges || ranges.length === 0) return <>{s}</>;
  const parts = splitHighlightRanges(s, ranges, current ?? -1);
  if (parts.length === 0) return <>{s}</>;
  return (
    <>
      {parts.map((p, i) => (p.hit ? (
        <span
          key={i}
          style={{
            background: p.current ? 'rgba(232,98,44,0.78)' : 'rgba(232,98,44,0.30)',
            borderRadius: 2,
          }}
        >
          {p.text}
        </span>
      ) : p.text))}
    </>
  );
}
